import { Dialog } from '@mui/material';
import React from 'react';
import AllocateForm from './AllocateForm';

const AllocateModal = ({
  isOpen,
  toggle,
  getData,
  singlePage,
  setSnackBarOpen,
  setSnackBarMessage,
  setSnackbarSeverity
}) => {
  return (
    <Dialog
      open={isOpen}
      keepMounted
      maxWidth="sm"
      fullWidth
      scroll="paper"
      onClose={toggle}
    >
      <AllocateForm
        toggle={toggle}
        getData={getData}
        singlePage={singlePage}
        setSnackBarOpen={setSnackBarOpen}
        setSnackBarMessage={setSnackBarMessage}
        setSnackbarSeverity={setSnackbarSeverity}
      />
    </Dialog>
  );
};

export default AllocateModal;
